import React, { useState } from "react";
import { Button, Checkbox, Modal, Space, Typography } from "antd";

const TERMS_ACCEPTED_KEY = "desafio_terms_accepted";

const termsText = `TÉRMINOS Y CONDICIONES DE USO

Aplicación de Desarrollo y Gestión de Personas "Desafío"

Esta aplicación es una experiencia gamificada de aprendizaje y desarrollo personal. No es una actividad oficial de la Universidad Tecnológica Nacional (UTN) ni compromete a la institución en ningún aspecto.

La misma fue desarrollada con fines académicos.

Los datos consignados no generan derechos ni obligaciones de carácter académico o legal ante ninguna institución.

1. IDENTIFICACIÓN Y ALCANCE

Los presentes Términos y Condiciones (en adelante "T&C") regulan el acceso y uso de la aplicación de Desarrollo y Gestión de Personas (en adelante "la App"), desarrollada como actividad gamificada integradora por el equipo del Desafío.

La App forma parte de una propuesta con propósito pedagógico y experimental. Su uso está limitado a los alumnos inscriptos en la Tecnicatura en Desarrollo y Producción de Videojuegos y en esta fase experimental versión Beta se invita a participar a los ingresantes de Agosto 2025.

Esta aplicación no constituye una actividad oficial de la Universidad Tecnológica Nacional (UTN). Toda la responsabilidad relativa al desarrollo, funcionamiento, contenidos, así como a la asignación de premios e insignias dentro de la App, recae exclusivamente en el equipo de Desarrollo del Desafío. Por lo tanto, cualquier aspecto vinculado con la gestión o utilización de la aplicación queda bajo la órbita exclusiva de dicho equipo sin generar compromisos, obligaciones por parte de la UTN.

2. ACEPTACIÓN DE LOS TÉRMINOS

El acceso y uso de la App implica la aceptación plena y sin reservas de los presentes Términos y Condiciones (T&C) por parte del usuario. Al iniciar sesión o hacer uso de cualquiera de las funcionalidades de la aplicación, el usuario manifiesta expresamente que ha leído, comprendido y aceptado cada una de las cláusulas aquí establecidas.

En caso de no estar conforme con alguna de las disposiciones, requisitos o reglas detalladas en los T&C, se solicita al usuario que se abstenga de utilizar la aplicación y sus servicios.

El uso de la App por parte de los alumnos se considera, en todos los casos, como una aceptación voluntaria y consciente de estas condiciones de uso.

3. ACCESO Y PERFIL DE USUARIO

El acceso a la App está reservado únicamente a los alumnos que se encuentren debidamente inscriptos y cursando en forma regular la Tecnicatura en Desarrollo y Producción de Videojuegos de UTN. De este modo, se garantiza que solo quienes participan formalmente de la propuesta educativa puedan utilizar las funcionalidades y servicios ofrecidos por la aplicación.

Cada usuario asume la responsabilidad exclusiva por la veracidad y exactitud de los datos que incorpora tanto en su perfil personal como en las distintas actividades desarrolladas dentro de la App. Esta obligación resulta fundamental para el correcto funcionamiento y la integridad de la experiencia educativa proporcionada.

4. CARGA Y GESTIÓN DE LOS DATOS

4.1 Los datos que los alumnos ingresan en la App —como información personal, el avance en las materias, las actividades realizadas y los datos del perfil— son utilizados de manera exclusivamente práctica y pedagógica, en el contexto del desarrollo de la app; siendo la recopilación y gestión de dichos datos tiene como único objetivo facilitar la experiencia de aprendizaje y la participación de los estudiantes en las actividades propuestas dentro del marco de la App.

Es importante destacar que los datos consignados en la plataforma tienen carácter experimental y de prueba. Por lo tanto, no generan ni pueden generar efectos académicos, contractuales o legales de ningún tipo para los usuarios.

La carga de datos se realiza en forma manual por parte del propio usuario. No existe importación automática desde sistemas académicos de la universidad.

4.2 Confidencialidad y permanencia de los datos

La plataforma garantiza la protección y privacidad de los datos que los usuarios ingresan durante el uso de la App.

Toda la información proporcionada permanecerá dentro de la plataforma, sin ser compartida ni exportada hacia sistemas externos. Esto significa que los datos ingresados por los usuarios se mantendrán exclusivamente en el entorno de la aplicación, resguardando su confidencialidad.

Toda la información allí cargada no será cedida a terceros ni utilizada con propósitos comerciales. El compromiso de la App es evitar cualquier tipo de transferencia de datos a otras entidades o personas ajenas al Desafío y descartar su uso para actividades que no sean estrictamente pedagógicas y relacionadas con la experiencia educativa y lúdica.

El acceso a los datos está restringido, permitiendo que únicamente el usuario y el equipo técnico del Desafío puedan consultarlos. De esta manera se preserva la privacidad y se asegura que la información personal, el avance en las materias y demás datos ingresados sean gestionados de manera segura y responsable, exclusivamente en el marco de la propuesta educativa.

4.3 Errores en la carga de datos

Dado el carácter práctico y experimental de la plataforma, pueden existir errores, inconsistencias o inconvenientes en la carga de datos. En todos estos casos:

Los errores no afectan, no modifican ni perjudican la cursada del alumno.

Los errores no tienen impacto en la situación académica del usuario.

El usuario deberá reportar el error a través de los canales de comunicación habilitados (ver Sección 8) para su corrección.

Ante cualquier error en los datos de la plataforma, la corrección es responsabilidad del Desafío. La facultad no asume responsabilidad alguna sobre los datos consignados en esta aplicación.

5. FUNCIONALIDADES DE LA APP

Los alumnos podrán cargar el avance y estado de sus materias dentro de la plataforma. Esta información es de carácter orientativo y no reemplaza ni modifica el registro oficial de la institución educativa.

La App cuenta con un sistema de progresión por niveles que refleja la participación y avance del usuario en las actividades de la cursada y otras propuestas. El cumplimiento de niveles es de carácter motivacional y no tiene valor curricular.

Los alumnos podrán ganar insignias digitales por su participación en las actividades. Estas insignias se reflejan en el avatar del usuario dentro de la plataforma y tienen un propósito exclusivamente motivacional y lúdico dentro del entorno de la App.

A fin de ganar más insignias, los alumnos deberán asistir a las actividades disponibles, las cuales son de participación gratuita para todos los alumnos inscriptos. No se cobrará ningún cargo adicional por el acceso ni por la participación en las actividades.

6. PREMIOS E INCENTIVOS

6.1 Los premios, incentivos y reconocimientos que puedan ofrecerse en el marco de las actividades de la App son otorgados y gestionados exclusivamente por el Desafío.

La facultad (UTN) no otorga ni se hace responsable de los premios ofrecidos a través de esta plataforma. Cualquier reclamo, consulta o inconveniente relacionado con premios debe dirigirse exclusivamente al equipo del Desafío, dentro del canal habilitado a tal fin.

6.2 Los alumnos inscriptos cuentan con una beca del 15% de descuento sobre la cuota mensual, vigente de octubre hasta el mes de diciembre inclusive del ciclo lectivo en curso. La beca es personal e intransferible y no es acumulable con otras promociones salvo indicación expresa de la Universidad (UTN).

Pasado el mes de diciembre, la cuota volverá a su valor regular sin necesidad de notificación adicional.

Para consultas sobre la beca y condiciones de pago, comunicarse por los canales habilitados indicados en la Sección 8.

7. LIMITACIÓN DE RESPONSABILIDAD

El equipo de Desarrollo del Desafío se reserva el derecho de:

a. Modificar, actualizar o interrumpir el funcionamiento de la App sin previo aviso.
b. Corregir errores técnicos o de carga de datos en cualquier momento.
c. Ajustar las condiciones de uso, niveles, insignias o beneficios ofrecidos.

En ningún caso el equipo del Desafío será responsable por:

a. Pérdida de datos ingresados por el usuario.
b. Decisiones tomadas por el usuario en base a información incorrectamente cargada.
c. Interrupciones del servicio por causas técnicas, de mantenimiento o de fuerza mayor.

8. CANALES DE COMUNICACIÓN

Para consultas, reportes de errores, reclamos sobre premios o cualquier otro inconveniente relacionado con la App, los alumnos deberán comunicarse exclusivamente con el Desafío a través de los canales habilitados.

Las consultas dirigidas a la facultad (UTN) sobre el funcionamiento de esta aplicación no serán respondidas por esa vía, ya que esta no es una actividad institucional de la UTN.

9. PROPIEDAD INTELECTUAL

La App, su diseño, lógica, elementos gráficos y contenidos son creaciones del equipo del Desafío.

Queda prohibida la reproducción, distribución o modificación de cualquier componente de la App sin autorización expresa de sus creadores.

La propiedad intelectual de la aplicación, incluyendo su diseño, lógica, elementos gráficos y contenidos, corresponde exclusivamente al Desafío, así como a su equipo de trabajo. En consecuencia, los alumnos no podrán reclamar derechos de ningún tipo sobre la creación de la App o sobre cualquiera de sus componentes.

10. MODIFICACIONES DE LOS T&C

El Equipo del Desafío podrá actualizar los presentes T&C en cualquier momento. Los cambios serán comunicados a los usuarios a través de los canales habilitados. El uso continuado de la App tras la notificación de cambios implica la aceptación de los nuevos términos.

Al utilizar la App, el alumno declara haber leído, comprendido y aceptado la totalidad de estos Términos y Condiciones.

El Desafío | 2026`;

const TermsModal: React.FC = () => {
  const [accepted, setAccepted] = useState(
    () => localStorage.getItem(TERMS_ACCEPTED_KEY) === "true",
  );
  const [checked, setChecked] = useState(false);

  const handleAccept = () => {
    localStorage.setItem(TERMS_ACCEPTED_KEY, "true");
    setAccepted(true);
  };

  if (accepted) return null;

  return (
    <Modal
      open
      centered
      closable={false}
      footer={null}
      width={880}
      maskStyle={{
        backgroundColor: "rgba(47, 43, 116, 0.85)",
        backdropFilter: "blur(4px)",
      }}
      styles={{
        body: {
          backgroundColor: "var(--dashboard-panel-bg)",
          border: "3px solid var(--dashboard-panel-border)",
          borderRadius: 24,
          boxShadow: "0 6px 0 rgba(62, 80, 147, 0.45)",
          maxHeight: "90vh",
          overflow: "hidden",
        },
      }}
    >
      <div style={{ padding: 28, textAlign: "center" }}>
        <Typography.Title
          level={3}
          className="outlined-title"
          style={{ margin: 0, marginBottom: 12 }}
        >
          Términos y Condiciones
        </Typography.Title>

        <div
          style={{
            border: "2px solid var(--dashboard-panel-border)",
            borderRadius: 16,
            background: "linear-gradient(180deg, #ffffff 0%, #f5f7ff 100%)",
            padding: 20,
            maxHeight: "50vh",
            overflowY: "auto",
            marginBottom: 16,
            textAlign: "left",
          }}
        >
          <Typography.Text
            style={{
              color: "var(--dashboard-text)",
              whiteSpace: "pre-line",
              lineHeight: 1.7,
              fontSize: 14,
            }}
          >
            {termsText}
          </Typography.Text>
        </div>

        <Space align="center" style={{ marginBottom: 20 }}>
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <Typography.Text
            style={{ color: "var(--dashboard-text)", fontWeight: 600 }}
          >
            He leído y acepto los Términos y Condiciones
          </Typography.Text>
        </Space>
      </div>

      <div
        style={{
          padding: "0 28px 28px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={handleAccept}
          disabled={!checked}
          type="primary"
          style={{
            minWidth: 200,
            background: checked
              ? "var(--dashboard-yellow)"
              : "var(--dashboard-track)",
            border: `2px solid ${checked ? "var(--dashboard-yellow-dark)" : "#aaa"}`,
            fontWeight: 800,
            borderRadius: 16,
            boxShadow: checked ? "0 4px 0 rgba(211, 158, 0, 0.95)" : "none",
            color: "var(--dashboard-header-blue)",
          }}
        >
          Aceptar y continuar
        </Button>
      </div>
    </Modal>
  );
};

export default TermsModal;
